import { createFileRoute } from "@tanstack/react-router";

import { AdminApprovalsPage } from "@/components/admin/AdminApprovalsPage";

export const Route = createFileRoute("/admin/approvals")({
  head: () => ({ meta: [{ title: "Approvals · GENRL Admin" }] }),
  component: AdminApprovalsPage,
});
